var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.34178 18.7819L7.41078 18.2639L8.19778 15.3249C7.01975 14.8904 5.9249 14.2572 4.96078 13.4529L2.80778 15.6069L1.39278 14.1919L3.54678 12.0389C2.33086 10.5826 1.51387 8.83563 1.17578 6.96886L3.14378 6.60986C3.90278 10.8119 7.57878 13.9999 11.9998 13.9999C16.4198 13.9999 20.0968 10.8119 20.8558 6.60986L22.8238 6.96786C22.4861 8.83488 21.6695 10.5822 20.4538 12.0389L22.6068 14.1919L21.1918 15.6069L19.0388 13.4529C18.0747 14.2572 16.9798 14.8904 15.8018 15.3249L16.5888 18.2649L14.6578 18.7819L13.8698 15.8419C12.6321 16.0539 11.3674 16.0539 10.1298 15.8419L9.34178 18.7819Z",
    fill: "#0F0F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.c2812647d67f669c9a52961e6bc1c037.svg";
export { ForwardRef as ReactComponent };